export default "__VITE_ASSET__CTEeaJ5y__"